<app-loader *ngIf="isDisabled || isGDisabled"></app-loader>
<div class="card">
    <form name="ClientHolidayForm" (ngSubmit)="ClientHolidayForm.form.valid && SaveClientHoliday()"
        #ClientHolidayForm="ngForm">
        <div class="card-header">
            <div class="card-title">Client Holiday Mapping</div>
        </div>
        <div class="card-body">
            <div>
                <form name="ClientHolidayFilterForm" (ngSubmit)="Validate(ClientHolidayFilterForm)"
                    #ClientHolidayFilterForm="ngForm" class="pb-2">
                    <div class="pt-1">
                        <div class="row pb-3">
                            <div class="col-md-2 px-1">
                                <label>Year</label>
                                <select name="Year" class="form-control form-select" [(ngModel)]="filter.Year"
                                    #Year="ngModel"
                                    (ngModelChange)="ClearHolidays();(this.filter.StateId != 0 && this.filter.StateId != null)?ComboLoad('StateWiseClient'):null "
                                    required [disabled]="DisablesFilter.Year">
                                    <option [value]=null disabled hidden>Select Year</option>
                                    <option *ngFor="let Year of Years" [value]="Year">
                                        {{Year}}
                                    </option>
                                </select>
                                <div class="invalid-feedback">
                                    Please select year!
                                </div>
                            </div>
                            <div class="col-md-3 px-1">
                                <label>State</label>
                                <ng-select name="State" id="State"
                                    (change)="ClearHolidays();ComboLoad('StateWiseClient')" [(ngModel)]="filter.StateId"
                                    placeholder="Select State" required [disabled]="DisablesFilter.State"
                                    [disabled]="this.filter.Year == null">
                                    <ng-option *ngFor="let State of StatesFilter"
                                        [value]="State.StateMasterID">{{State.StateName}}</ng-option>
                                </ng-select>
                                <div class="invalid-feedback">
                                    Please select state.
                                </div>
                            </div>
                            <div class="col-md-5 px-1">
                                <label>Client</label>
                                <ng-select [items]="ClientsFilter" [multiple]="true" bindLabel="ClientGroupName"
                                    name="muliex" [selectableGroup]="false" [selectableGroupAsModel]="false"
                                    placeholder="Select Client" [closeOnSelect]="false" bindValue="ClientGroupMasterID"
                                    [clearable]="false" [(ngModel)]="filter.ClientIdObj" (click)="CheckDiselect()"
                                    required [disabled]="this.filter.Year == null">

                                    <ng-template ng-header-tmp let-items="items">
                                        <input type="checkbox" (change)="CheckAll($event,'Client')" /> Check All
                                    </ng-template>

                                    <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                                        <input id="item-{{index}}" name="item-{{index}}" type="checkbox"
                                            [ngModel]="item$.selected"
                                            [disabled]="common.ToLowerCase(item.IsClientMapped) == 'mapped' && item.ESS_ClientOnStateHolidayMasterId != this.filter.ESS_ClientOnStateHolidayMasterId"
                                            [ngModelOptions]="{ standalone : true }" />
                                        {{item.ClientGroupName}}
                                    </ng-template>

                                    <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                                        <div class="ng-value" *ngFor="let item of items.slice(0,1)">
                                            <span class="ng-value-label">{{item.ClientGroupName}}</span>
                                        </div>
                                        <div class="ng-value" *ngIf="items.length > 1">
                                            <span class="ng-value-label">{{items.length - 1}} +...</span>
                                        </div>
                                    </ng-template>
                                </ng-select>
                                <div class="invalid-feedback">
                                    Please select client.
                                </div>
                            </div>
                            <div class="col-md-1 px-1 pt-4">
                                <button type="submit" class="btn btn-primary text-nowrap" [disabled]="isDisabled">
                                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                        *ngIf="isDisabled"></span>
                                    {{!isDisabled?'Get Holiday':'Loading...'}}</button>
                            </div>
                        </div>
                    </div>
                </form>

            </div>
            <div class="row">
                <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                    class="customeDatatable table table-bordered">
                    <thead class="table-light">
                        <tr>
                            <th>Holiday Name</th>
                            <th style="width: 150px">Date</th>
                            <th style="width: 250px;">Not Applicable/Compulsory/Optional</th>
                        </tr>
                    </thead>
                    <tbody>

                        <tr *ngFor="let element of ClientHolidayData;let i=index">
                            <td>{{element.HolidayName}}</td>
                            <td style="width: 150px">{{element.Date}}</td>
                            <td style="width: 250px">
                                <div style="width: 250px;">
                                    <select name="TypesOfLeave__{{i+1}}" placeholder="Select types of leave"
                                        [(ngModel)]="element.TypesOfLeave" #TypesOfLeave="ngModel">
                                        <option *ngFor="let TypesOfLeave of TypesOfLeaves" [value]="TypesOfLeave">
                                            {{TypesOfLeave}}
                                        </option>
                                    </select>
                                </div>
                            </td>

                        </tr>
                    </tbody>

                </table>
            </div>
        </div>
        <div class="card-footer">
            <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                <button type="button" class="btn btn-outline-secondary btn-sm" [disabled]="isDisabled"
                    (click)="close()"><i class="bi bi-x" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Cancel':'Loading...'}}</button>

                <button
                    *ngIf="(this.common.PageRight.IsAdd && this.filter.ESS_ClientOnStateHolidayMasterId == 0) || (this.common.PageRight.IsEdit && this.filter.ESS_ClientOnStateHolidayMasterId > 0)"
                    type="submit" class="btn btn-primary text-nowrap" [disabled]="isDisabled"><i class="bi bi-save"
                        *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Save':'Loading...'}}</button>
            </div>
        </div>
    </form>
</div>